import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AnuncioInteresse } from '../../models/anuncio-interesse.model';
import { Anuncio } from '../../models/anuncio.model';
import { UtilService } from '../../../shared/services/util.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { AnuncioInteresseService } from '../../services/anuncio-interesse.service';
import { CadastroAnuncioService } from 'app/anuncio/services/cadastro-anuncio.service';
import { Router } from '@angular/router';
import { OrigemEnum } from 'app/shared/enum/origem.enum';
import { AnuncioTipoEnum } from 'app/shared/enum/anuncio-tipo.enum';

@Component({
  selector: 'alterar-tipo-anuncio',
  templateUrl: './alterar-tipo-anuncio.component.html',
  styleUrls: ['./alterar-tipo-anuncio.component.scss']
})
export class AlterarTipoAnuncioComponent implements OnInit {



  @Input()
  show: boolean = false;

  //evento para avisar que finalizou a análise
  @Output()
  analiseEfetuada = new EventEmitter<AnuncioInteresse>();

  //indica se deve exibir o modal de analisar interesse
  exibirModalAlterarTipoAnuncio: boolean =  false;

  //formulário 'Tenho Interesse'
  formulario: FormGroup = this.formBuilder.group({
    tipo: [null, Validators.required]
  });

  //anuncio interesse a ser analisado
  anuncio: Anuncio = {} as Anuncio;

  //tipo de republicação do anúncio
  anuncioTipoTic: number = 0;

  listaTiposAnuncios: Array<{ id: AnuncioTipoEnum, nome: string }> = [
    { id: AnuncioTipoEnum.GENERICO, nome: 'Anúncio padrão' },
    { id: AnuncioTipoEnum.TIC, nome: 'Anúncio de Bens de TIC - Lei nº 14.479/2022' }
  ];

  tipoSelecionadoValue: { id: AnuncioTipoEnum, nome: string } | undefined = { id: AnuncioTipoEnum.GENERICO, nome: 'Anúncio padrão' };

  constructor(
    private formBuilder: FormBuilder,
    private utilService: UtilService,
    private messageService: MessageService,
    private cadastroAnuncioService: CadastroAnuncioService,
    private router: Router,
    private anuncioInteresseService: AnuncioInteresseService,
  ) { }

  ngOnInit() {

  }

  /**
   * Exibir modal.
   */
  abrirModalAlterarTipoAnuncio(anuncio: Anuncio) {
    this.anuncio = anuncio;
    this.tipoSelecionadoValue = this.listaTiposAnuncios.find(tipo => tipo.id === this.anuncio.anuncioTipo.id);
    this.exibirModalAlterarTipoAnuncio = true;

  }

  onCancelar() {
    this.ocultarModal();
  }

  /**
   * Ocultar modal.
   */
  ocultarModal() {
    this.exibirModalAlterarTipoAnuncio = false;
  }


  public onTipoTicChange(value: number) {
    this.anuncioTipoTic = value;
  }

  public podeAlterarSeEBensTic(): boolean {
        return !this.anuncio.mensagemBloqueio;
  }


  public onConfirmar():void {

    if(this.podeAlterarSeEBensTic() && this.tipoSelecionadoValue && this.anuncio.anuncioTipo.id !== this.tipoSelecionadoValue.id) {

      this.anuncio.anuncioTipo = { id: this.tipoSelecionadoValue.id, nome: this.tipoSelecionadoValue.nome };
      this.cadastroAnuncioService.atualizarAnuncioGoverno(this.anuncio).subscribe(
      (resultado: any) => {
        this.messageService.add({severity:'success', summary:'Sucesso', detail:resultado.mensagem});

        // navega para página de meus anúncio
        this.router.navigate([OrigemEnum.MEUS_ANUNCIOS_GOVERNO]);
         setTimeout(() => window.location.reload(), 1000);
      }, () => { });
    }
      this.ocultarModal();
  }



}
